import { Chat, ChatParticipantStatus } from '@tribeplatform/gql-client/types'
import { Sidebar } from '@tribeplatform/react-ui-kit/Sidebar'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { T } from '../../i18n/index.js'
import { useChatContext } from '../ChatContext/ChatContext.js'
import { ChatImage } from '../components/ChatImage.js'

import { CloseDetailsButton } from './CloseDetailsButton.js'
import { GroupChatActions } from './GroupChatActions.js'
import { GroupParticipantsList } from './GroupParticipantsList.js'
import { ParticipantDetails } from './ParticipantDetails.js'

interface Props {
  chat: Chat
}

export const GroupChatDetails = ({ chat }: Props) => {
  const { showChatDetails, selectedParticipant, setSelectedParticipant } =
    useChatContext()
  const isStillParticipant =
    chat.currentParticipant?.status === ChatParticipantStatus.Active
  /**
   * @todo: get the name from the participants
   */
  const name = chat.name ?? '...'

  if (!showChatDetails) {
    return null
  }

  if (selectedParticipant) {
    return (
      <div className="animate-fade-in">
        <ParticipantDetails
          participant={selectedParticipant}
          chat={chat}
          onClose={() => setSelectedParticipant(null)}
        />
      </div>
    )
  }

  return (
    <Sidebar
      size="auto"
      withBorder={false}
      className="rounded-base flex flex-col"
    >
      <Sidebar.Header className="py-8 px-4 sm:pb-8 relative justify-center border-b border-line-subdued sticky bg-surface top-0 z-10">
        <div className="absolute top-4 left-3 ">
          <CloseDetailsButton />
        </div>
        <div className="flex flex-col items-center gap-4 min-w-0 overflow-hidden">
          <ChatImage
            size="6x"
            name={name}
            imageUrl={chat.avatarUrl}
            type={chat.type}
          />
          <Text className="text-lg font-semibold text-content line-clamp-2 max-w-full text-center">
            {name}
          </Text>
        </div>
      </Sidebar.Header>
      <Sidebar.Content className="p-0 flex-none max-h-fit">
        {isStillParticipant && (
          <GroupParticipantsList
            chat={chat}
            onParticipantClick={setSelectedParticipant}
          />
        )}
        {!isStillParticipant && (
          <div className="p-5 text-center whitespace-pre-wrap">
            <T
              id="Messaging.GroupChatDetails.LeftMessage"
              defaultMessage="You are no longer a {MEMBER} of this group chat."
            />
          </div>
        )}
      </Sidebar.Content>
      {isStillParticipant && (
        <Sidebar.Footer className="p-0">
          <GroupChatActions chat={chat} />
        </Sidebar.Footer>
      )}
    </Sidebar>
  )
}
